
import React from 'react';
import { SensorDetailSidebarProps } from './SensorDetailShared';
import { SEODetail } from './SEODetail';
import { SEMDetail } from './SEMDetail';
import { SELDetail } from './SELDetail';
import { SESDetail } from './SESDetail';
import { RADARDetail } from './RADARDetail';
import { SEVDetail } from './SEVDetail';
import { useTranslation } from 'react-i18next';

export function SensorDetailSidebar({ sensor, onBack, onClose, onUpdateSensor, onShowToast }: SensorDetailSidebarProps) {
  const { t } = useTranslation();
  if (sensor.type === 'SEL') {
    return <SELDetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} onShowToast={onShowToast} />;
  }
  if (sensor.type === 'SES') {
    return <SESDetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} onShowToast={onShowToast} />;
  }
  if (sensor.type === 'RADAR') {
    return <RADARDetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} />;
  }
  if (sensor.type === 'SEM') {
    return <SEMDetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} onShowToast={onShowToast} />;
  }
  if (sensor.type === 'SEO' || sensor.type === 'SER') {
    return <SEODetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} onShowToast={onShowToast} />;
  }
  if (sensor.type === 'SEV' || sensor.type === 'HERV') {
    return <SEVDetail sensor={sensor} onBack={onBack} onClose={onClose} onUpdateSensor={onUpdateSensor} onShowToast={onShowToast} />;
  }
  
  return (
    <div className="w-full flex items-center justify-center p-3 border-l border-white/20 bg-[#0a0f1a]/30 h-full text-slate-500 font-roboto text-sm">
      {t('zone.unknown_sensor_type')}
    </div>
  );
}
